import React, { useState } from "react";
import { Icon } from "@iconify/react";
import { Table, Tag } from "antd";
import { useNavigate } from "react-router-dom";
import DelTableRowModal from "../../../modals/delTableRowModal";
import { useTranslation } from "react-i18next";
const data = [
  {
    key: "1",
    contractType: "Employment",
    partyInfo: "ABC Corp, John Doe",
    effectiveDate: "01-12-2023",
    expiryDate: "29-05-2023",
    status: "Finalized",
    terms: "60 days notice before renewal",
  },
  {
    key: "2",
    contractType: "Sale of Goods",
    partyInfo: "XYZ Ltd., Emily Davis",
    effectiveDate: "15-11-2023",
    expiryDate: "25-05-2023",
    status: "Draft",
    terms: "Termination upon breach of conditions",
  },
  {
    key: "3",
    contractType: "Lease",
    partyInfo: "Smith Properties, Michael Brown",
    effectiveDate: "08-05-2023",
    expiryDate: "23-05-2023",
    status: "Executed",
    terms: "30-day notice for termination",
  },
  {
    key: "4",
    contractType: "C004",
    partyInfo: "John Doe",
    effectiveDate: "06-03-2023",
    expiryDate: "25-05-2023",
    status: "Finalized",
    terms: "60 days notice before renewal",
  },
  {
    key: "5",
    contractType: "C005",
    partyInfo: "Emily Davis",
    effectiveDate: "01-03-2023",
    expiryDate: "13-05-2023",
    status: "Draft",
    terms: "Termination upon breach of conditions",
  },
  {
    key: "6",
    contractType: "C006",
    partyInfo: "John Doe",
    effectiveDate: "01-05-2023",
    expiryDate: "01-05-2023",
    status: "Executed",
    terms: "30-day notice for termination",
  },
];
const ContractTable = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [isdelModalOpen, setIsdelModalOpen] = useState(false);
  const onDelClick = () => {
    setIsdelModalOpen(true);
  };
  const columns = [
    {
      title: t("dashboard.contractManagement.contractType"),
      dataIndex: "contractType",
      key: "contractType",
      render: (text) => <p className="text-darkGrey small font-poppins">{text}</p>,
    },
    {
      title: t("dashboard.contractManagement.partyInfo"),
      dataIndex: "partyInfo",
      key: "partyInfo",
      render: (partyInfo) => <p className="text-darkGrey small font-poppins">{partyInfo}</p>,
    },
    {
      title: t("dashboard.contractManagement.effectiveDate"),
      dataIndex: "effectiveDate",
      key: "effectiveDate",
      render: (date) => <p className="text-darkGrey small font-poppins">{date}</p>,
    },
    {
      title: t("dashboard.contractManagement.expiryDate"),
      dataIndex: "expiryDate",
      key: "expiryDate",
      render: (date) => <p className="text-darkGrey small font-poppins">{date}</p>,
    },
    {
      title: t("dashboard.contractManagement.contractStatus"),
      dataIndex: "status",
      key: "status",
      render: (status) => (
        <Tag
          color={status === "Executed" ? "green" : status === "Finalized" ? "orange" : "red"}
          className="rounded-[54px] border-none px-3 py-1 text-white font-medium e-small"
        >
          {status}
        </Tag>
      ),
    },
    {
      title: t("dashboard.contractManagement.terms"),
      dataIndex: "terms",
      key: "terms",
      render: (terms) => <p className="text-darkGrey small font-poppins">{terms}</p>,
    },
    {
      title: t("dashboard.contractManagement.actions"),
      key: "actions",
      render: () => (
        <div className="flex gap-[18px]">
          <p
            className="text-secondary cursor-pointer flex justify-center items-center small font-poppins w-[83px] h-[34px] bg-[#D3EFF4] rounded-[47px]"
            onClick={() => {
              navigate("/contract/contract-details");
            }}
          >
            {t("dashboard.contractManagement.details")}
          </p>
          <img
            src="../../assets/icons/del.png"
            alt=""
            className="cursor-pointer"
            onClick={onDelClick}
          />
        </div>
      ),
    },
  ];
  return (
    <>
      {" "}
      <Table
        columns={columns}
        dataSource={data}
        pagination={{
          position: ["bottomCenter"],
          pageSize: 6,
          itemRender: (current, type, originalElement) => {
            if (type === "prev") {
              return (
                <div className="bg-[#DADDE1] w-[36px] h-[36px] rounded-[9px] flex items-center justify-center">
                  <Icon icon="ep:arrow-left-bold" color="#143A62" />
                </div>
              );
            }
            if (type === "next") {
              return (
                <div className="bg-[#DADDE1] w-[36px] h-[36px] rounded-[9px] flex items-center justify-center">
                  <Icon icon="ep:arrow-right-bold" color="#143A62" />
                </div>
              );
            }
            return originalElement;
          },
          showSizeChanger: false,
          className: "custom-pagination",
        }}
        className="w-full"
        scroll={{ x: "1000px" }}
      />
      <DelTableRowModal isdelModalOpen={isdelModalOpen} setIsdelModalOpen={setIsdelModalOpen} />
    </>
  );
};

export default ContractTable;
